(function () {
  if (window.nwBundleGridInitialized) return;
  window.nwBundleGridInitialized = true;

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    try {
      return amount.toLocaleString(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function getCheckedRadio() {
    return document.querySelector('[data-nw-bundle-grid-radio]:checked');
  }

  function syncCtaFromRadio(radio) {
    if (!radio) return;
    var price = radio.getAttribute('data-price');
    var comparePrice = radio.getAttribute('data-compare-price');
    var onetimePrice = radio.getAttribute('data-onetime-price') || price;
    var onetimeComparePrice = radio.getAttribute('data-onetime-compare-price') || comparePrice;
    var isAvailable = radio.getAttribute('data-available') !== 'false';

    document.querySelectorAll('[data-nw-bundle-grid-price]').forEach(function (el) {
      el.textContent = formatMoney(price);
    });

    document.querySelectorAll('[data-nw-bundle-grid-compare]').forEach(function (el) {
      var hasCompare = comparePrice && Number(comparePrice) > Number(price);
      el.textContent = hasCompare ? formatMoney(comparePrice) : '';
      el.hidden = !hasCompare;
    });

    document.querySelectorAll('[data-nw-bundle-grid-onetime]').forEach(function (el) {
      var total = onetimeComparePrice && Number(onetimeComparePrice) > 0 ? onetimeComparePrice : onetimePrice;
      el.textContent = formatMoney(total);
    });

    document.querySelectorAll('[data-nw-bundle-grid-add]').forEach(function (button) {
      button.disabled = !isAvailable;
      button.querySelectorAll('[data-nw-bundle-grid-normal]').forEach(function (el) {
        el.hidden = !isAvailable;
      });
      button.querySelectorAll('[data-nw-bundle-grid-sold-out-text]').forEach(function (el) {
        el.hidden = isAvailable;
      });
    });
  }

  function bindRadios() {
    document.querySelectorAll('[data-nw-bundle-grid-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) syncCtaFromRadio(radio);
      });
    });
    syncCtaFromRadio(getCheckedRadio());
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.dataset.originalText = button.querySelector('[data-nw-bundle-grid-price]')
        ? ''
        : button.dataset.originalText;
      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');
    }
  }

  function bindAddToCart() {
    document.querySelectorAll('[data-nw-bundle-grid-add]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var radio = getCheckedRadio();
        if (!radio) return;

        var variantId = radio.value;
        var purchaseType = button.getAttribute('data-purchase-type') || 'onetime';
        var lineItem = { id: variantId, quantity: 1 };

        if (purchaseType === 'subscription') {
          var sellingPlanId = parseInt(radio.getAttribute('data-selling-plan'), 10);
          if (sellingPlanId > 0) lineItem.selling_plan = sellingPlanId;
        }

        setButtonLoading(button, true);

        window.__cartDrawerUpdating = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [lineItem] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw new Error(err.message || 'Add to cart failed'); });
            return res.json();
          })
          .then(function () {
            if (window.cartDrawerCustom) {
              window.cartDrawerCustom.refresh().then(function () {
                window.cartDrawerCustom.open();
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:open'));
            }
          })
          .catch(function (err) {
            console.error('[NwBundleGrid] add to cart failed', err);
          })
          .finally(function () {
            setButtonLoading(button, false);
            window.__cartDrawerUpdating = false;
          });
      });
    });
  }

  function init() {
    bindRadios();
    bindAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
